import {
  Box,
  Container,
  IconButton,
  styled,
  Typography,
  Tooltip,
  listSubheaderClasses,
  List,
  ListItem,
  ListItemText,
  TextField,
  InputAdornment,
  Button,
} from "@mui/material";
import React from "react";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import {
  TfiDribbble,
  TfiFacebook,
  TfiInstagram,
  TfiPinterest,
  TfiTwitter,
  TfiYoutube,
} from "react-icons/tfi";
import Zoom from "@mui/material/Zoom";
import { Link } from "react-router-dom";

const LogoString = styled((props) => (
  <Typography variant={"h4"} {...props}>
    {props.children}
  </Typography>
))(({ theme }) => ({
  fontFamily: "lato",
  fontWeight: 400,
  letterSpacing: theme.spacing(2),
  color: "#9A9A9A",
}));

const MuiIconButton = styled((props) => (
  <IconButton {...props}>{props.children}</IconButton>
))(({ theme }) => ({
  color: "white",
  background: "black",
  transition: "0.4s",
}));
const FooterList = ({ title, list }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "start",
      justifyContent: "center",
      width: { xs: "100%", sm: "50%", md: "auto", lg: "auto" },
    }}
  >
    <Typography
      variant={"body1"}
      sx={{
        lineHeight: "50px",
        fontFamily: "lato",
        textTransform: "uppercase",
        fontSize: "1.2rem",
        fontWeight: 400,
        color: "white",
        letterSpacing: 2,
      }}
    >
      {title}
    </Typography>
    <List>
      {list.map((item, index) => (
        <ListItem sx={{ px: 0 }} key={index}>
          <Link
            className="listItemLinkFooter"
            style={{ fontFamily: "lato, sans-serif", textDecoration: "none" }}
            to={item.link}
          >
            {item.title}
          </Link>
        </ListItem>
      ))}
    </List>
  </Box>
);
export const StyledIconButton = React.forwardRef((props, ref) => (
  <MuiIconButton ref={ref} {...props}>
    {props.children}
  </MuiIconButton>
));

export default function Footer() {
  return (
    <Box sx={{ py: 12, background: "#000000", color: "white" }}>
      <Container>
        <Box
          sx={{
            justifyContent: { xs: "start", md: "space-between" },
            display: "flex",
            flexWrap: "wrap",
            width: "100%",
            flexDirection: { xs: "column", sm: "row", md: "row", lg: "row" },
            gap: { xs: 5, sm: 0, md: 2, lg: 3 },
            py: 4,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 3,
              alignItems: "start",
              justifyContent: "center",
              width: { xs: "100%", sm: "50%", md: "auto", lg: "auto" },
            }}
          >
            <LogoString>GECKO</LogoString>
            <Box sx={{ display: "flex", flexDirection: "row", gap: 1.2 }}>
              <LocationOnOutlinedIcon
                sx={{
                  fontSize: "30px",
                  verticalAlign: "middle",
                  stroke: "black",
                  strokeWidth: "1",
                }}
              />
              <Typography
                variant="body2"
                sx={{ color: "white", fontFamily: "lato,sans-serif" }}
              >
                184 Main Rd E, St Albans
                <br />
                VIC 3021, Australia
              </Typography>
            </Box>

            <Box sx={{ display: "flex", flexDirection: "row", gap: 1.2 }}>
              <EmailOutlinedIcon
                sx={{
                  fontSize: "30px",
                  verticalAlign: "middle",
                  stroke: "black",
                  strokeWidth: "1",
                }}
              />
              <Typography
                variant="body2"
                sx={{ color: "white", fontFamily: "lato,sans-serif" }}
              >
                contact@company.com
              </Typography>
            </Box>

            <Box sx={{ display: "flex", flexDirection: "row", gap: 1.2 }}>
              <CallOutlinedIcon
                sx={{
                  fontSize: "30px",
                  verticalAlign: "middle",
                  stroke: "black",
                  strokeWidth: "1",
                }}
              />
              <Typography
                variant="body2"
                sx={{ color: "white", fontFamily: "lato,sans-serif" }}
              >
                +001 2233 456
              </Typography>
            </Box>

            <Box>
              <Tooltip
                TransitionComponent={Zoom}
                TransitionProps={{ timeout: 300 }}
                title="Follow On Facebook"
                arrow
                placement="top"
              >
                <div style={{ display: "inline-block" }}>
                  <StyledIconButton
                    sx={{
                      "&:hover": {
                        transform: "translate(0,-5px)",
                        color: "#0071BD",
                      },
                    }}
                  >
                    <TfiFacebook style={{ fontSize: "20px" }} />
                  </StyledIconButton>
                </div>
              </Tooltip>

              <Tooltip
                TransitionComponent={Zoom}
                TransitionProps={{ timeout: 300 }}
                title="Follow On Twitter"
                arrow
                placement="top"
              >
                <div style={{ display: "inline-block" }}>
                  <StyledIconButton
                    sx={{
                      "&:hover": {
                        transform: "translate(0,-5px)",
                        color: "aqua",
                      },
                    }}
                  >
                    <TfiTwitter style={{ fontSize: "20px" }} />
                  </StyledIconButton>
                </div>
              </Tooltip>

              <Tooltip
                TransitionComponent={Zoom}
                TransitionProps={{ timeout: 300 }}
                title="Follow On Instagram"
                arrow
                placement="top"
              >
                <div style={{ display: "inline-block" }}>
                  <StyledIconButton
                    sx={{
                      "&:hover": {
                        transform: "translate(0,-5px)",
                        color: "#0071BD",
                      },
                    }}
                  >
                    <TfiInstagram style={{ fontSize: "20px" }} />
                  </StyledIconButton>
                </div>
              </Tooltip>

              <Tooltip
                TransitionComponent={Zoom}
                TransitionProps={{ timeout: 300 }}
                title="Follow On Dribble"
                arrow
                placement="top"
              >
                <div style={{ display: "inline-block" }}>
                  <StyledIconButton
                    sx={{
                      "&:hover": {
                        transform: "translate(0,-5px)",
                        color: "blue",
                      },
                    }}
                  >
                    <TfiDribbble style={{ fontSize: "20px" }} />
                  </StyledIconButton>
                </div>
              </Tooltip>

              <Tooltip
                TransitionComponent={Zoom}
                TransitionProps={{ timeout: 300 }}
                title="Follow On Pinterest"
                arrow
                placement="top"
              >
                <div style={{ display: "inline-block" }}>
                  <StyledIconButton
                    sx={{
                      "&:hover": {
                        transform: "translate(0,-5px)",
                        color: "red",
                      },
                    }}
                  >
                    <TfiPinterest style={{ fontSize: "20px" }} />
                  </StyledIconButton>
                </div>
              </Tooltip>

              <Tooltip
                TransitionComponent={Zoom}
                TransitionProps={{ timeout: 300 }}
                title="Follow On Youtube"
                arrow
                placement="top"
              >
                <div style={{ display: "inline-block" }}>
                  <StyledIconButton
                    sx={{
                      "&:hover": {
                        transform: "translate(0,-5px)",
                        color: "red",
                      },
                    }}
                  >
                    <TfiYoutube style={{ fontSize: "20px" }} />
                  </StyledIconButton>
                </div>
              </Tooltip>
            </Box>
          </Box>

          <FooterList
            title="CATEGORIES"
            list={[
              { title: "Men", link: "" },
              { title: "Women", link: "" },
              { title: "Accessories", link: "" },
              { title: "Shoes", link: "" },
              { title: "Denim", link: "" },
              { title: "Dress", link: "" },
            ]}
          />
          <FooterList
            title="INFORMATION"
            list={[
              { title: "About Us", link: "" },
              { title: "Contact Us", link: "" },
              { title: "Terms & Conditions", link: "" },
              { title: "Returns & Exchanges", link: "" },
              { title: "Shipping & Delivery", link: "" },
              { title: "Privacy Policy", link: "" },
            ]}
          />
          <FooterList
            title="USEFUL LINKS"
            list={[
              { title: "Store Location", link: "" },
              { title: "Latest News", link: "" },
              { title: "My Account", link: "" },
              { title: "Size Guide", link: "" },
              { title: "Portfolio", link: "" },
              { title: "FAQs", link: "" },
            ]}
          />

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: { xs: "center", sm: "start" },
              textAlign: "center",
              width: { xs: "100%", sm: "50%", md: "auto", lg: "auto" },
            }}
          >
            <Typography
              variant={"body1"}
              sx={{
                lineHeight: "50px",
                fontFamily: "lato",
                textTransform: "uppercase",
                fontSize: "1.2rem",
                fontWeight: 400,
                color: "white",
                letterSpacing: 2,
              }}
            >
              NEWSLETTER SIGNUP
            </Typography>
            <Typography variant={"body1"} sx={{ width: "250px" }}>
              Subscribe to our newsletter and get 10% off your first purchase
            </Typography>

            <Box
              sx={{
                width: "100%",
                display: "flex",
                alignItems: { sm: "start", md: "center" },
                justifyContent: "center",
                flexDirection: "column",
                mt: 3,
                gap: 2,
              }}
            >
              <TextField
                width={"100%"}
                id="emailsub"
                label=""
                variant="outlined"
                sx={{
                  background: "white",

                  borderRadius: "30px",
                  ".MuiInputBase-root": {
                    borderRadius: "30px",
                    border: "1px solid white",
                    fieldset: { border: "none" },
                  },
                }}
                //   value={}
                //   onChange={}
                placeholder="your email address"
              />
              <Button variant="contained" color="error" sx={{}}>
                Subscribe
              </Button>
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
